import styled from "styled-components"
import ReactHTMLTableToExcel from 'react-html-table-to-excel';




export const Page= styled.div`
  margin: 0px 100px;
  


  @media screen and (max-width: 950px){
    margin: 0;
    padding: 5px;
  }
`

export const DashContainer = styled.div`
    display: flex;
    background-color: black;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    filter: brightness(${props => props.degree});

  @media screen and (max-width: 400px){
    height: 100%;
  }
  

  @media screen and (max-height: 900px){
    height: 100%;
  }


`

export const PageHead = styled.header`
    position: sticky;

`

export const DashContent = styled.section`
  color: white;
  margin: 10px 20px;
  text-align: center; 
  display: flex;
  flex-direction: column;
  height: inherit;
`
export const DashHead = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;


`
export const DashHeadCaption = styled.h1`
    color: white;
    font-size: 32px;
    font-weight: bold;
`

export const DashSelectWrapper = styled.div`
  display: flex;
  flex-direction:row;
  justify-content:space-between;

  @media screen and (max-width:600px){
    flex-direction:column ;
    align-items:center;
    /* justify-content:center; */
  }
 
`

export const DashInputWrapper = styled.div`
  margin-top:40px;
  display: flex;
  flex-direction:column;
  width: 400px;
  position: relative;

  @media screen and (max-width: 400px){
    width: 325px;
  }
`

export const DashInput = styled.div`
  border: 1px #595959 solid;
  height: 53px;
  border-radius:10px;
  padding: 0px 10px;
  display: flex;
  text-align:left;
  align-items:center;
  font-weight:600;
  justify-content:space-between;
`
export const DashInputText = styled.div`
  text-align:left;
  align-items:center;
  font-weight:600;
`
export const DashInputImg = styled.img`
  width: 15px;
  height: 15px;
  transform: rotate(${props => props.rotate});
`

export const DashOptionWrapper = styled.div`
    display: ${props => props.display};
    width: 100%;
    position: absolute;
    top: 99%;
    left:0;
    z-index:1;
    box-shadow: 0 7px 29px 0 rgb(0 0 0 / 30%);
    border-radius:4px;
    overflow:auto;

`
export const DashInputOption = styled.button`
  color: white;
  display: flex;
  width: 100%;
  border: none;
  background-color:#262626 ;
  border-top: 0.01cm #595959 solid; 
  font-size:16px;
  padding: 7.75px;

  &:hover{
    background-color:#40a9ff ;
  }


`
export const DashTable = styled.div`
  display: flex;
  width: 100%;
  margin-top: 40px;

  @media screen and (max-width: 500px){
    width: inherit;
    margin-top:3vh;
  }

  
`


export const ExportTable = styled(ReactHTMLTableToExcel)`
  background-color: rgba(64, 169, 255, 0.2);
  border-bottom-color: rgb(64, 169, 255);
  border: none;
  color: rgb(64, 169, 255);
  padding: 16px 20px;
  margin-top:40px;
  height: 56px;
  font-weight:600;
  border-radius:10px ;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;

  
`  
export const ExportPdf = styled.button`
  background-color: rgba(64, 169, 255, 0.2);
  border-bottom-color: rgb(64, 169, 255);
  border: none;
  color: rgb(64, 169, 255);
  padding: 16px 20px;
  margin-top:40px;
  height: 56px;
  font-weight:600;
  border-radius:10px ;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin-left: 10px;

  
`  

export const DashSelectRight = styled.div`
  height:100%;
`